/**
 * Wake Lock Utility
 *
 * Keeps the screen awake during workouts using the Screen Wake Lock API
 * Fallback to NoSleep.js pattern if Wake Lock API is not supported
 */

class WakeLockManager {
  constructor() {
    this.wakeLock = null;
    this.isSupported = 'wakeLock' in navigator;
  }

  /**
   * Request wake lock to keep screen awake
   */
  async request() {
    if (!this.isSupported) {
      console.warn('Wake Lock API not supported in this browser');
      return false;
    }

    try {
      this.wakeLock = await navigator.wakeLock.request('screen');

      // Re-request wake lock when page becomes visible again
      this.wakeLock.addEventListener('release', () => {
        console.log('Wake Lock was released');
      });

      console.log('Wake Lock is active');
      return true;
    } catch (err) {
      console.error(`Wake Lock error: ${err.name}, ${err.message}`);
      return false;
    }
  }

  /**
   * Release wake lock
   */
  async release() {
    if (this.wakeLock) {
      try {
        await this.wakeLock.release();
        this.wakeLock = null;
        console.log('Wake Lock released manually');
        return true;
      } catch (err) {
        console.error(`Wake Lock release error: ${err.name}, ${err.message}`);
        return false;
      }
    }
    return false;
  }

  /**
   * Check if wake lock is currently active
   */
  isActive() {
    return this.wakeLock !== null && !this.wakeLock.released;
  }

  /**
   * Re-request wake lock (useful for page visibility changes)
   */
  async reacquire() {
    if (!this.isActive()) {
      return await this.request();
    }
    return true;
  }
}

// Export singleton instance
export const wakeLockManager = new WakeLockManager();
export default wakeLockManager;
